module.exports = {"data":{"site":{"siteMetadata":{"title":"Speer : Make sales relevant, not loud"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 112
// module chunks = 60335399758886 114276838955818